import React from "react";
import "../styles/Footer.css";
import logo from "../images/s-logo.png";

import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaXTwitter,
  FaPhone,
  FaEnvelope,
  FaLocationDot,
  FaArrowUpRightFromSquare,
} from "react-icons/fa6";

const Footer = () => {
  return (
    <footer className="footer">

      {/* TOP BAR */}
      <div className="footer-top">
        <img src={logo} alt="Savannah Shine Hub" className="footer-logo" />

        <a href="/services" className="book-link">
          Book Appointment
          <FaArrowUpRightFromSquare />
        </a>
      </div>

      {/* MIDDLE SECTION */}
      <div className="footer-container">

        {/* About */}
       
        <div className="footer-about">
          <p>
            Savannah Shine Hub is your all-in-one service hub in Kenya. 
            From professional car wash and deep carpet cleaning to reliable 
            water refill, barber services, and a relaxing cafe experience, 
            we bring convenience, quality, and care closer to you.
          </p>

          <div className="socials">
            <FaFacebookF />
            <FaInstagram />
            <FaXTwitter />
            <FaLinkedinIn />
          </div>
        </div>

        {/* Services */}
        <div className="footer-links">
          <h4>Our Services</h4>
          <a href="/car-wash">Car Wash</a>
          <a href="/carpet-pickup">Carpet Cleaning</a>
          <a href="/water-refill">Water Refill</a>
          
        </div>

  

        {/* Info */}
        <div className="footer-links">
          <h4>Info</h4>
          <a href="/contact-us">Contact</a>
          <a href="/about-us">About</a>
          </div>

        {/* Contact */}
        <div className="footer-contact">
          <h4>Contact</h4>

          <div className="contact-item">
            <FaPhone />
            <span>+254 119 117 744</span>
          </div>

          <div className="contact-item">
            <FaEnvelope />
            <span>info@savannahshinehub.com</span>
          </div>

          <div className="contact-item">
            <FaLocationDot />
            <span>Nothern Bypass Junction, <br/> 100m along Kwaheri Rd</span>
          </div>
        </div>
      </div>

      {/* BOTTOM */}
      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} Savannah Shine Hub. All rights reserved.</p>

        
      </div>
    </footer>
  );
};

export default Footer;